import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLinkActive, RouterLink } from '@angular/router';
import { IccCapture } from 'app/core/models/icc/icc-capture.model';
import { IccCaptureService } from 'app/core/services/icc/icc-capture.service';
import { NavigationService } from 'app/core/services/navigation.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-icc-capture-detail',
    templateUrl: './icc-capture-detail.component.html',
    styleUrls: ['./icc-capture-detail.component.scss'],
    imports: [RouterLinkActive, RouterLink, FaIconComponent, MatProgressSpinner, CurrencyPipe, DatePipe]
})
export class IccCaptureDetailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);
  private iccCaptureService = inject(IccCaptureService);

  public refreshing = true;
  public captureId: string;
  public capture: IccCapture;

  ngOnInit(): void {
    this.captureId = this.route.snapshot.paramMap.get('id');

    this.loadCapture(this.captureId);
  }

  private loadCapture(id: string): void {
    this.refreshing = true;
    this.iccCaptureService.getCapture(id).subscribe(
      (capture) => {
        this.capture = capture;
        this.refreshing = false;
      },
      (err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.navigationService.notFound();
        } else {
          console.error(err);
        }
      }
    )
  }

}
